document.addEventListener("DOMContentLoaded", function() {
  const sliderClasses = ['.multi-slider', '.multi-usage-flex', '.multicolumn-slider', '.benefits-slider-mbl'];

  function initMultiSliders() {
    sliderClasses.forEach(selector => {
      if (window.innerWidth <= 768) {
        if (!$(selector).hasClass('slick-initialized')) {
          $(selector).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            autoplay: true,
            pauseOnHover: false,
            infinite: true,
            speed: 1000,
          });
        }
      } else {
        if ($(selector).hasClass('slick-initialized')) {
          $(selector).slick('unslick');
        }
      }
    });
  }

  initMultiSliders();

  window.addEventListener('resize', function() {
    initMultiSliders();
  });
});

